module.exports = __webpack_public_path__ + "static/img/walmart.ef7f302.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/walmart.png
// module id = DXcY
// module chunks = 1